import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';

import { BrowserRouter as Router } from 'react-router-dom'
import { LanguageProvider } from './i18n/LanguageContext';

ReactDOM.render(
  <LanguageProvider>
    <Router>
      <App />
    </Router>
  </LanguageProvider>,
  document.getElementById('root')
)